import { render, staticRenderFns } from "./TeamOverview.vue?vue&type=template&id=23fb1232"
import script from "./TeamOverview.vue?vue&type=script&lang=ts"
export * from "./TeamOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports